export enum TimeUnitEnum {
  SECONDS = "seconds",
  MINUTES = "minutes",
  HOURS = "hours",
  DAYS = "days"
}

export const TimeUnitLabels = {
  [TimeUnitEnum.SECONDS]: "Segundos",
  [TimeUnitEnum.MINUTES]: "Minutos",
  [TimeUnitEnum.HOURS]: "Horas",
  [TimeUnitEnum.DAYS]: "Dias"
}
